interface NavAttributes {
    [propName: string]: any;
}
interface NavWrapper {
    attributes: NavAttributes;
    element: string;
}
interface NavBadge {
    text: string;
    variant: string;
}
interface NavLabel {
    class?: string;
    variant: string;
}

export interface NavData {
    name?: string;
    url?: string;
    icon?: string;
    badge?: NavBadge;
    title?: boolean;
    children?: NavData[];
    variant?: string;
    attributes?: NavAttributes;
    divider?: boolean;
    class?: string;
    label?: NavLabel;
    wrapper?: NavWrapper;
}

export const navItems: NavData[] = [
    {
        name: 'Indicadores',
        url: '/dashboard',
        icon: 'icon-speedometer'
    },
    {
        title: true,
        name: 'Operación'
    },
    {
        name: 'Reporte Actividades',
        url: '/views/task/report',
        icon: 'icon-list'
    },
    {
        name: 'Reporte Tiendas',
        url: '/StoreReport',
        icon: 'fa fa-bar-chart',
        children: [
            {
                name: 'Tiendas',
                url: '/StoreReport',
                icon: 'fa fa-bar-chart'
            },
            /*
            {
                name: 'CheckList',
                url: '/StoreReportCheckList',
                icon: 'fa fa-list-alt'
            }
            */
        ]
    },
    {
        name: 'Acciones Correctivas',
        url: '/actions',
        icon: 'cui-task icons'
    },
    {
        name: 'Programar Actividades',
        url: '/admin',
        icon: 'cui-calendar icons'
    },
    {
        name: 'Administrar Plantillas',
        url: '/template',
        icon: 'cui-layers icons'
    },
    {
        divider: true
    },
    {
        title: true,
        name: 'Inventarios'
    },
/*     {
        name: 'Ingreso de Mercancía',
        url: '/inventory/shipments',
        icon: 'fa fa-cubes'
    }, */
    {
        name: 'Ingreso de Mercancía',
        url: '/inventory',
        icon: 'fa fa-truck',
        children: [
            {
                name: 'Ingreso de Mercancía',
                url: '/inventory/shipments',
                icon: 'fa fa-cubes'
            },
            {
                name: 'Ingreso de Mercancia ASN',
                url: 'inventory/shipments-asn',
                icon: 'fa fa-cubes'
            },
        ]
    },
    {
        name: 'Recepciones',
        url: '/inventory/receptions',
        icon: 'fa fa-cube'
    },
    {
        name: 'Traspasos Corporativo',
        url: '/transfer/corporate',
        icon: 'fa fa-share-square'
    },
    {
        name: 'Traspasos Tienda',
        url: '/transfer/store',
        icon: 'fa fa-share-square-o'
    },
    {
        name: 'Traspasos en Transito',
        url: 'transfer/consigment',
        icon: 'fa fa-share-square-o'
    },
    {
        name: 'Inventario',
        url: '/inventory/counts',
        icon: 'fa fa-pencil-square',
        children: [
            {
                name: 'Físico',
                url: '/inventory/counts/physical',
                icon: 'fa fa-book'
            },
            {
                name: 'Pre-planchado',
                url: '/inventory/counts/pressed',
                icon: 'fa fa-list-alt'
            }
        ]
    },
    /* {
        name: 'Ingreso Mercancia ASN',
        url: '/inventory/shipments-asn',
        icon: 'fa fa-truck'
    }, */
    {
        name: 'Devoluciones',
        url: '/return',
        icon: 'fa fa-undo',
        children: [
            {
                name: 'Devoluciones Programadas',
                url: '/return/return-corporate',
                icon: 'fa fa-file-text'
            },
            {
                name: 'Solicitudes de Devolución por Defecto',
                url: '/return/return-request',
                icon: 'fa fa-pencil-square'
            },
            {
                name: 'Devoluciones por Defecto',
                url: '/return/return-store',
                icon: 'fa fa-retweet'
            },
        ]
    },
    {
        name: 'Artículos negados para venta',
        url: '/inventory/unsold-item-size',
        icon: 'fa fa-ban'
    },
    /*
    {
        name: 'Facturación',
        url: '/invoicement/report',
        icon: 'fa fa-google-wallet'
    },
    */
    {
        divider: true
    },
    {
        title: true,
        name: 'Configuración'
    },
    {
        name: 'Administrar Tiendas',
        url: '/config/stores',
        icon: 'icon-tag icons'
    },
    {
        name: 'Admin. Dispositivos',
        url: '/config/device-admin',
        icon: 'cui-tablet'
    },
    {
        name: 'Coleccionador de imagenes',
        url: '/image-collector',
        icon: 'fa fa-file-image-o'
    },
    {
        name: 'Admin. Tiendas por usuario',
        url: '/config/organization-chart',
        icon: 'cui-globe'
    },
    //Se oculta menú debido a que ya no realiza ninguna acción en Quantum
    /*
    {
        name: 'Admin. Empleados',
        url: '/config/employee-admin',
        icon: 'cui-people'
    },
    */
    {
        name: 'Admin. Zonas',
        url: '/config/zone-admin',
        icon: 'icon-map'
    },
    {
        name: 'Admin. Módulos',
        url: 'config/module-admin',
        icon: 'icon-grid'
    },
    {
        name: 'Restock',
        url: 'restock/restock-new',
        icon: 'icon-list'
    },
    {
        name: 'Restock Report',
        url: 'restock/restock-report',
        icon: 'fa fa-file'
    },
    {
        name: 'Diseño de Etiquetas',
        url: 'config/price-label',
        icon: 'icon-tag'
    },
    {
        name: 'Logger Layouts',
        url: 'config/logger-layouts',
        icon: 'fa fa-exclamation-triangle'
    },
    {
        name: 'Admin. Usuarios',
        url: '/return',
        icon: 'fa fa-users',
        children: [
            {
                name: 'Admin. Usuarios',
                url: 'config/users-admin',
                icon: 'fa fa-users'
            },
            {
                name: 'Admin. Roles',
                url: 'config/roles-admin',
                icon: 'fa fa-shield'
            },
        ]
    },
];
